import { createSlice } from '@reduxjs/toolkit';

const initial = { hasCustomLink: false, status: '', link: '' };

const slice = createSlice({
  name: 'customLinks',
  initialState: initial,
  reducers: {
    setCustomLinks: (state, { payload }) => ({ ...payload }),
    setHasCustomLink: (state, { payload }) => ({
      ...state,
      hasCustomLink: payload,
    }),
    setData: (state, { payload }) => ({
      ...payload,
    }),
    restore: () => initial,
  },
});

export const { setCustomLinks, setHasCustomLink, setData, restore } =
  slice.actions;

export default slice.reducer;

export const selectCustomLinks = (state) => state.customLinks;
